import { render, staticRenderFns } from "./AreaAddUpdate.vue?vue&type=template&id=11e717fd&scoped=true"
import script from "./AreaAddUpdate.vue?vue&type=script&lang=js"
export * from "./AreaAddUpdate.vue?vue&type=script&lang=js"
import style0 from "./AreaAddUpdate.vue?vue&type=style&index=0&id=11e717fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e717fd",
  null
  
)

export default component.exports